export default __webpack_public_path__ + "static/media/BatteriesEqImg.a5df12d5.jpg";